import { ComponentStyleConfig } from "@chakra-ui/react";

const AccordionTheme: ComponentStyleConfig = {
  variants: {
    contentBlock: {
      root: {
        ".chakra-accordion__item": {
          mb: "16px",
        },
      },
      container: {
        borderWidth: 1,
        borderColor: "gray.200",
        bg: "white",
        boxShadow: "sm",
        mt: 0,
        borderRadius: "8px",
        overflow: "hidden",
      },
      panel: {
        paddingTop: 0,
        paddingInline: "64px",
        paddingBottom: "48px",
      },
      button: {
        py: 0,
        px: "20px",
        minHeight: "48px",
        textColor: "gray.600",
        userSelect: "none",
        borderRadius: "8px",
        _expanded: {
          borderBottomRadius: 0,
        },
        "&.has-title": {
          cursor: "pointer",
          minHeight: "48px",
        },
        "& p": {
          textStyle: "bodyBold",
        },
        _hover: {
          bg: "unset",
          "&:not(:has(.mb-content-block-actions:hover))": {
            bg: "gray.50",
          },
        },
      },
      icon: {
        width: "24px",
        height: "24px",
      },
    },
  },
};

export default AccordionTheme;
